export class EmployeeUpdateReq{
    id:number
    isAvailable:boolean
    constructor(
        id:number,
        isAvailable:boolean
    ){
        this.id = id
        this.isAvailable = isAvailable
    }
}